"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Labels = void 0;
exports.Labels = {
    noInternetHeading: 'Keine Internetverbindung',
    noInternetMessage: 'Hoppla! Die Internetverbindung scheint offline zu sein.',
    noInternetButtonText: 'Tippe zum neu laden',
    genericErrorHeading: 'Hoppla! Da ist etwas schief gelaufen.',
    genericErrorMessage: 'Versuche, die Seite neu zu laden.',
    genericErrorButtonText: 'Seite neu laden',
};
